import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "~/components/ui/breadcrumb"
import { Link, useLocation } from "@remix-run/react"
import { Home } from "lucide-react"
import { urlPattern } from "~/utils/urlPattern"
import { useQuery } from "@tanstack/react-query"
import { CategoryItem } from "~/.server/api/routers/workspace"

export function WorkspaceBreadcrumb({ title }: { title?: string }) {
  const location = useLocation()
  const { city, category, space } = urlPattern.parse(location.pathname)
  const { data: categories } = useQuery<CategoryItem[]>({ queryKey: ['categories'] })

  if (!city) return null

  const formattedCity = city.charAt(0).toUpperCase() + city.slice(1)
  const categoryName = category ? 
    categories?.find(c => c.value === category)?.label || 
    category.charAt(0).toUpperCase() + category.slice(1) : 
    null

  const getLastItem = () => {
    if (space) return title
    if (category) return categoryName
    return formattedCity
  }

  return (
    <Breadcrumb>
      <BreadcrumbList>
        <BreadcrumbItem>
          <BreadcrumbLink asChild>
            <Link to="/"><Home className="h-4 w-4" /></Link>
          </BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbSeparator />
        <BreadcrumbItem>
          <BreadcrumbLink asChild>
            <Link to={urlPattern.build({ city })}>{formattedCity}</Link>
          </BreadcrumbLink>
        </BreadcrumbItem>
        {category && !space && (
          <>
            <BreadcrumbSeparator />
            <BreadcrumbPage>{categoryName}</BreadcrumbPage>
          </>
        )}
        {space && categoryName && (
          <>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to={urlPattern.build({ city, category })}>{categoryName}</Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbPage>{getLastItem()}</BreadcrumbPage>
          </>
        )}
      </BreadcrumbList>
    </Breadcrumb>
  )
}
